import { useCallback, useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { API_CONFIG } from 'shared/constants/constant'
import { ScaleBoatIcon } from 'shared/icon/icon'
import httpService from 'shared/services/http.service'
import ScaleDemo from './scaleDemo'

const ScaleBoat = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [token, setToken] = useState({ token: '', expiry: '', url: '' })

    const getToken = useCallback(async () => {
        if (!token.token) {
            try {
                const data = await httpService.post(`${API_CONFIG.path.token}`);
                setToken(data)

                return token;
            } catch (error) {
                toast.error('Failed to fetch token.');
                console.error('Token fetch error:', error);
                return null;
            }
        }

        return token;
    }, [token]);

    useEffect(() => {
        getToken();
    }, [getToken]);

    return (
        <div className='bot-wrapper1 h-screen'>
            {!isOpen && <div onClick={() => setIsOpen(!isOpen)} className="w-[65px] h-[65px] flex items-center justify-center fixed bottom-[32px] right-[32px] bg-[#25ADD0] cursor-pointer rounded-full">
                {/* <ChatIcon className='w-[26px] h-[26px]' /> */}
                <ScaleBoatIcon className='w-[26px] h-[26px]' />
            </div>
            }
            {isOpen && <div className='content-container'>
                <ScaleDemo onClose={() => setIsOpen(false)} getToken={getToken} token={token} />
            </div>}

        </div>
    )
}

export default ScaleBoat